export const getQuillDataTestId = (id) => `quill-editor-${id}`;
